'use client';
import styled, { css } from 'styled-components';

function getBackground(props) {
  if (props.$tag) {
    return props.theme.colors.background.checked;
  }
  if (props.checked) {
    return props.theme.colors.neutral.cream;
  }
  return props.theme.colors.background.base;
}

function getBackgroundOnHover(props) {
  if (props.$tag) {
    return props.theme.colors.background.checked;
  }
  if (!props.checked) {
    return props.theme.colors.background.base;
  }
  return getBackground(props);
}

function getBorderColor(props) {
  if (props.$tag) {
    return props.theme.colors.border.dark;
  }
  if (props.checked) {
    return props.theme.colors.border.dark;
  }
  return props.theme.colors.neutral.cream;
}

function getBorderColorOnHover(props) {
  if (props.$tag) {
    return props.theme.colors.border.dark;
  }
  if (!props.checked) {
    return props.theme.colors.text.primary;
  }
  return getBorderColor(props);
}

export const Button = styled.button`
  ${props => props.theme.typography.label}

  align-items: center;
  background: ${getBackground};
  border: 1px solid ${getBorderColor};
  display: inline-flex;
  margin: ${({ margin }) => margin};
  padding: 0
    ${({ size, $tag }) => ($tag ? '10px' : size === 'small' ? '8px' : '20px')};
  user-select: none;
  color: ${props =>
    props.$tag
      ? props.theme.colors.text.secondary
      : props.theme.colors.text.primary};

  height: ${({ size, $tag }) => {
    if ($tag) {
      return '32px';
    }
    if (size === 'small') {
      return '34px';
    }
    if (size === 'large') {
      return '56px';
    }
    return '48px';
  }};

  border-radius: ${({ size, $tag }) => {
    if ($tag) {
      return '16px';
    }
    if (size === 'small') {
      return '16px';
    }
    if (size === 'large') {
      return '28px';
    }
    return '24px';
  }};

  ${props =>
    props.$tag &&
    css`
      padding-left: 4px;
    `}

  &:hover {
    background: ${getBackgroundOnHover};
    border-color: ${getBorderColorOnHover};
  }

  &:focus {
    outline: 0;
    border: 2px solid
      ${props =>
        props.$tag
          ? props.theme.colors.border.dark
          : props.theme.colors.text.primary};
    /* subtract 1px from the padding for the 2px border width */
    padding: 0
      ${({ size, $tag }) => ($tag ? '9px' : size === 'small' ? '7px' : '19px')};
    ${props =>
      props.$tag &&
      css`
        padding-left: 3px;
      `}
  }
`;

export const IconContainer = styled.div`
  display: flex;
  margin-right: 11px;
`;

export const CloseIconContainer = styled.div`
  display: flex;
  margin-right: ${props => (props.$tag ? '6px' : '10px')};

  ${props =>
    props.$tag &&
    css`
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-color: ${props.theme.colors.hero.lilac};
    `}
`;

export const Text = styled.div`
  margin-right: ${props => (props.$tag ? '0' : '10px')};
  color: ${props =>
    props.$tag
      ? props.theme.colors.text.secondary
      : props.theme.colors.text.primary};
`;
